(() => {
  const init = root => {
    if (root.dataset.xmasReady) return;
    root.dataset.xmasReady = 'true';
    const labels = JSON.parse(root.querySelector('[data-xmas-labels]').textContent);
    const cards = [...root.querySelectorAll('[data-gift-card]')];
    const gifts = cards.map(card => ({...JSON.parse(card.querySelector('[data-gift-data]').textContent), image: card.querySelector('img')?.currentSrc || card.querySelector('img')?.src, card}));
    const money = amount => new Intl.NumberFormat(root.dataset.locale || 'it', {style:'currency', currency:root.dataset.currency || 'EUR'}).format(amount / 100);
    const filters = {recipient:'all',budget:'all'};
    const filter = () => {
      let count = 0;
      cards.forEach(card => {
        const price = Number(card.dataset.price);
        const recipient = filters.recipient === 'all' || filters.recipient === 'per-te' || card.dataset.recipient.split(' ').includes(filters.recipient);
        const budget = filters.budget === 'all' || filters.budget === '10' && price <= 1000 || filters.budget === '20' && price <= 2000 || filters.budget === 'over' && price > 2000;
        card.hidden = !(recipient && budget);
        if (!card.hidden) count++;
      });
      root.querySelector('[data-results]').textContent = labels.results.replace('__COUNT__', count);
      root.querySelector('[data-no-results]').hidden = count > 0;
      root.querySelectorAll('[data-department]').forEach(group => {group.hidden = ![...group.querySelectorAll('[data-gift-card]')].some(card => !card.hidden);});
      root.querySelectorAll('[data-filter]').forEach(set => set.querySelectorAll('button').forEach(button => {button.setAttribute('aria-pressed', String(button.dataset.value === filters[set.dataset.filter]));}));
    };
    root.querySelectorAll('[data-filter]').forEach(set => set.addEventListener('click', event => {const button = event.target.closest('button');if (!button) return; filters[set.dataset.filter] = button.dataset.value;filter();}));
    root.querySelector('[data-reset]').addEventListener('click', () => {filters.recipient = filters.budget = 'all';filter();});
    const params = new URLSearchParams(location.search);
    if (['10','20','over'].includes(params.get('budget'))) filters.budget = params.get('budget');
    if (['per-lei','per-lui','per-te','piccoli','speciali'].includes(params.get('per'))) filters.recipient = params.get('per');
    const contextHeading = root.querySelector('[data-finder-heading]');
    const contextIntro = root.querySelector('[data-finder-intro]');
    const baseHeading = contextHeading?.textContent;
    const baseIntro = contextIntro?.textContent;
    const contextualize = () => {
      if(!contextHeading || !contextIntro)return;
      const heading = filters.budget==='20'?labels.budget20:filters.budget==='10'?labels.budget10:filters.recipient==='per-lui'?labels.for_him:filters.recipient==='per-lei'?labels.for_her:filters.recipient==='per-te'?labels.for_self:baseHeading;
      contextHeading.textContent=heading;
      contextIntro.textContent=filters.budget==='20'?labels.budget20_intro:filters.budget==='10'?labels.budget10_intro:baseIntro;
    };
    root.querySelectorAll('[data-filter],[data-reset]').forEach(control=>control.addEventListener('click',contextualize));
    filter();contextualize();
    const form = root.querySelector('[data-compose-form]');
    const productSelect = group => form.querySelector(`[data-compose-product="${group}"]`);
    const variantSelect = group => form.querySelector(`[data-compose-variant="${group}"]`);
    const chosen = group => gifts.find(g => g.handle === productSelect(group).value);
    const variant = group => chosen(group)?.variants.find(v => String(v.id) === variantSelect(group).value && v.available);
    const submit = form.querySelector('[data-compose-submit]');
    const status = form.querySelector('[data-compose-status]');
    const summary = form.querySelector('[data-compose-summary]');
    const total = form.querySelector('[data-compose-total]');
    let adding = false;
    const multiChoices = {beauty:[],gadget:[]};
    const multiFields = {};
    ['beauty','gadget'].forEach(group => {
      const fields = document.createElement('div');
      fields.dataset.multiOptions = group;
      variantSelect(group).after(fields);
      multiFields[group] = fields;
    });
    const option = (text, value, disabled = false) => {const node = document.createElement('option');node.textContent = text;node.value = value;node.disabled = disabled;return node;};
    summary.setAttribute('aria-live','polite');
    const update = () => {
      summary.replaceChildren();let sum = 0;let pending = false;let any = false;
      ['beauty','gadget'].forEach(group => {
        const gift = chosen(group), selected = variant(group);
        if (!gift) return;
        any = true;
        if(selected) sum += Number(selected.price); else pending = true;
        const row = document.createElement('div');row.className = 'emal-xmas-summary-item';
        const img = document.createElement('img');img.src = selected?.featured_image?.src || gift.image;img.alt = '';img.width = 72;img.height = 72;img.loading='lazy';
        const text = document.createElement('span');
        const role = document.createElement('b');role.className='emal-xmas-summary-role';role.textContent=group==='beauty'?labels.summary_main:labels.summary_extra;
        const title = document.createElement('span');title.textContent = gift.title;
        const small = document.createElement('small');small.textContent = selected ? selected.public_title || selected.title : labels.summary_pending;
        text.append(role,title,small);
        const price = document.createElement('strong');price.textContent = selected ? money(selected.price) : '—';
        row.append(img,text,price);summary.append(row);
      });
      if(!any){const empty=document.createElement('p');empty.className='emal-xmas-summary-empty';empty.textContent=labels.summary_empty;summary.append(empty);}
      total.textContent = pending ? '—' : sum ? money(sum) : '—';
      total.setAttribute('aria-label',pending?labels.summary_estimate:money(sum));
      submit.disabled = adding || !variant('beauty') || Boolean(chosen('gadget') && !variant('gadget'));
      status.textContent = '';
    };
    const renderOptions = group => {
      const gift = chosen(group), fields = multiFields[group], select = variantSelect(group);
      fields.replaceChildren();
      const dimensions = gift?.variants[0]?.options?.length || 1;
      if (dimensions < 2) return;
      for (let index = 0; index < dimensions; index++) {
        const label = document.createElement('label'), choice = document.createElement('select');
        choice.id = `${productSelect(group).id}-option-${index}`;
        label.htmlFor = choice.id;
        label.textContent = gift.option_names?.[index] || labels.choose;
        choice.required = true;
        choice.disabled = multiChoices[group].slice(0,index).some(value => !value);
        choice.append(option(labels.choose,''));
        const values = [...new Set(gift.variants.map(v => v.options[index]))];
        values.forEach(value => {
          const available = gift.variants.some(v => v.available && v.options[index] === value && multiChoices[group].slice(0,index).every((prior,i) => !prior || v.options[i] === prior));
          choice.append(option(`${value}${available ? '' : ' · ' + labels.unavailable}`,value,!available));
        });
        choice.value = multiChoices[group][index] || '';
        choice.addEventListener('change', () => {
          multiChoices[group][index] = choice.value;
          for (let next = index + 1; next < dimensions; next++) multiChoices[group][next] = '';
          renderOptions(group);
          fields.querySelectorAll('select')[Math.min(index + 1, dimensions - 1)].focus({preventScroll:true});
          update();
        });
        fields.append(label,choice);
      }
      const match = gift.variants.find(v => v.available && v.options.every((value,i) => value === multiChoices[group][i]));
      select.value = match ? String(match.id) : '';
    };
    const populate = group => {
      const gift = chosen(group), select = variantSelect(group), label = form.querySelector(`[data-variant-label="${group}"]`);
      const variants = gift?.variants || [];
      select.replaceChildren();select.hidden = !gift || variants.length === 1;label.hidden = select.hidden;select.disabled = !gift;select.required = Boolean(gift && variants.length > 1);
      multiFields[group].replaceChildren();
      multiChoices[group] = [];
      if (gift) {
        if (variants.length !== 1) select.append(option(labels.choose, ''));
        variants.forEach(v => select.append(option(`${v.public_title || v.title} · ${money(v.price)}${v.available ? '' : ' · ' + labels.unavailable}`, String(v.id), !v.available)));
        if (!variants.some(v => v.available)) {select.replaceChildren(option(labels.unavailable,''));}
        if ((variants[0]?.options?.length || 1) > 1) {
          select.hidden = true;label.hidden = true;select.required = false;
          multiChoices[group] = new Array(variants[0].options.length).fill('');
          renderOptions(group);
        }
      }
      update();
    };
    ['beauty','gadget'].forEach(group => {
      gifts.filter(g => g.group === group).map(g => {
        const prices = g.variants.map(v => Number(v.price)).filter(Number.isFinite);
        if (!prices.length) prices.push(Number(g.card.dataset.price));
        const minimum = Math.min(...prices), maximum = Math.max(...prices);
        return {gift:g,minimum,maximum};
      }).sort((a,b) => a.minimum - b.minimum).forEach(({gift:g,minimum,maximum}) => {
        const price = minimum === maximum ? money(minimum) : `${money(minimum)} – ${money(maximum)}`;
        productSelect(group).append(option(`${price} — ${g.menu_title || g.title}`, g.handle, !g.variants.some(v => v.available)));
      });
      productSelect(group).addEventListener('change', () => populate(group));
      variantSelect(group).addEventListener('change', update);
    });
    const preselect = params.get('regalo');
    if (gifts.some(g => g.group === 'beauty' && g.handle === preselect && g.variants.some(v => v.available))) {productSelect('beauty').value = preselect;populate('beauty');}
    update();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (adding || submit.disabled || !form.reportValidity()) return;
      const beauty = variant('beauty'), gadget = variant('gadget');
      if (!beauty || chosen('gadget') && !gadget) return;
      adding = true;submit.disabled = true;submit.textContent = labels.adding;status.textContent = '';form.setAttribute('aria-busy','true');
      const controls = [...form.querySelectorAll('select')].map(element => ({element,disabled:element.disabled}));
      controls.forEach(control => {control.element.disabled = true;});
      const pair = `Natale-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,7)}`;
      const items = [{id:beauty.id,quantity:1,properties:{[labels.pack_key]:labels.pack_beauty,[labels.pair_key]:pair}}];
      if (gadget) items.push({id:gadget.id,quantity:1,properties:{[labels.pack_key]:labels.pack_gadget,[labels.pair_key]:pair}});
      try {
        const response = await fetch(root.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || labels.error);
        location.assign(root.dataset.cartUrl);
      } catch (error) {adding = false;form.removeAttribute('aria-busy');controls.forEach(control => {control.element.disabled = control.disabled;});submit.textContent = labels.add;update();status.textContent = error.message || labels.error;}
    });
  };
  document.querySelectorAll('[data-xmas-shop]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-xmas-shop]').forEach(init));
})();
